var render, staticRenderFns
import script from "./StatusBarChart.vue?vue&type=script&lang=js&"
export * from "./StatusBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b2a5a",
  null
  
)

export default component.exports